import React from "react";
import EventSummaryItem from "../../../stores/domainStore/pages/models/eventSummaryItem";
import EventSummary from "../../molecules/eventSummary/eventSummary";
import EventDateHeadingFormat from "../../atoms/eventDateHeadingFormat/eventDateHeadingFormat";
import {Row} from "reactstrap";
import classNames from "classnames";
import "./eventSummaryDayColumn.sass";

export interface IEventSummaryDayColumnProps {
  dayDate: Date;
  events: EventSummaryItem[];
  isReleaseDate: boolean;
  isFutureReleaseDate: boolean;
  calendarScheduleStartDate?: Date;
  onEventClick: (event: EventSummaryItem) => void;
}

const EventSummaryDayColumn: React.FC<IEventSummaryDayColumnProps> = ({
  dayDate,
  events,
  isReleaseDate,
  isFutureReleaseDate,
  calendarScheduleStartDate,
  onEventClick
}) => {
  return (
    <div
      data-testid="eventSummaryDayColumn"
      className={"eventSummaryDayColumn"}
    >
      <EventDateHeadingFormat
        date={dayDate}
        isReleaseDate={isReleaseDate}
        isFutureReleaseDate={isFutureReleaseDate}
      />
      {events
        //All day events go to the top, events at the same time order by title, otherwise order by start time
        .sort((a, b) =>
          a.allDay === true
            ? -1
            : a.start.getTime() === b.start.getTime()
            ? a.title.localeCompare(b.title)
            : a.start < b.start
            ? -1
            : 1
        )
        .map((e) => (
          <Row
            key={`${e.id}_${e.extendedProps.eventStartDateTimeOffSet}`}
            noGutters
          >
            <button
              onClick={() => onEventClick(e)}
              className={classNames("eventSummaryButton", {
                "unreleased-header-background-summary": isReleaseDate,
                "future-unrelese": isFutureReleaseDate
              })}
            >
              <EventSummary
                data={e}
                calendarScheduleStartDate={calendarScheduleStartDate}
              />
            </button>
          </Row>
        ))}
    </div>
  );
};

export default EventSummaryDayColumn;
